import {debounce} from '../_functions'

document.addEventListener("DOMContentLoaded", function (dom) {
    const achievementList = dom.target.querySelectorAll('.feed-achievement');
    const searchInput = dom.target.querySelector('.js-search-input');
    const categorySelect = dom.target.querySelector('.js-category');
    const categorySelect2 = dom.target.querySelector('.js-category-2');

    if (achievementList.length && searchInput && categorySelect && categorySelect2) {
        const filterAchievements = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();
            achievementList.forEach(achievement => {
                const title = achievement.querySelector('.texts__title');
                const titleText = title ? title.innerText.toLowerCase() : '';
                const achievementTerms = JSON.parse(achievement.dataset.terms || '[]');
                const achievementTerms2 = JSON.parse(achievement.dataset.terms2 || '[]');

                const matchSearch = searchTerm === '' || titleText.includes(searchTerm);
                const matchCategory = categorySelect.value === '' || achievementTerms.includes(categorySelect.value);
                const matchCategory2 = categorySelect2.value === '' || achievementTerms2.includes(categorySelect2.value);

                if (matchSearch && matchCategory && matchCategory2) {
                    achievement.classList.remove('hidden');
                } else {
                    achievement.classList.add('hidden');
                }
            });
        };

        const handleInput = debounce(filterAchievements, 300);
        searchInput.addEventListener('input', handleInput);
        categorySelect.addEventListener('change', filterAchievements);
        categorySelect2.addEventListener('change', filterAchievements);

        filterAchievements();
    }
});
